import { FC, useState } from 'react'

import { Attribute, AttributeLabel, AttributeValue } from 'packages/eid-ui'
import { ApplicationUserCard } from '../UserCard'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'

export const ApplicationOwnerDeputies: FC<any> = ({ label, data }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const noOfItems = 2
    const [showMore, setShowMore] = useState(
        data.length > noOfItems ? true : false,
    )

    const bindUserInfo = (users: any) => {
        if (users && users.length > 0) {
            if (showMore) {
                // eslint-disable-next-line
                return users.map((item: any, index: number) => {
                    if (index < noOfItems)
                        return (
                            <ApplicationUserCard
                                key={`application-apprvers-${index}`}
                                data={item}
                            />
                        )
                })
            } else {
                return users.map((item: any, index: number) => (
                    <ApplicationUserCard
                        key={`application-apprvers-${index}`}
                        data={item}
                    />
                ))
            }
        } else {
            return '-'
        }
    }

    return (
        <Attribute orientation="horizontal">
            <AttributeLabel>{label}</AttributeLabel>
            <AttributeValue
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                }}
            >
                {bindUserInfo(data)}{' '}
                {showMore ? (
                    <p
                        style={{
                            fontSize: '13px',
                            margin: '0',
                            marginTop: '2px',
                            color: theme?.palette?.primary?.main,
                            cursor: 'pointer',
                        }}
                        onClick={() => setShowMore(!showMore)}
                    >
                        + {data.length - noOfItems} {t('Common_More')}
                    </p>
                ) : (
                    data.length > noOfItems && (
                        <p
                            onClick={() => setShowMore(!showMore)}
                            style={{
                                fontSize: '13px',
                                margin: '0',
                                marginTop: '2px',
                                color: theme?.palette?.primary?.main,
                                cursor: 'pointer',
                            }}
                        >
                            {t('Common_ShowLess')}
                        </p>
                    )
                )}
            </AttributeValue>
        </Attribute>
    )
}
